{
  "0056ce5e7561ee81": "Enviar invitación en su lugar",
  "006f457d56bae1c7": "ya ha pasado. ¿Cuánto tiempo deben tener los profesionales para reservar este turno?",
  "00a1c21554fb52f6": "Cargo extra por hora",
  "00cd58f655daed8a": "Escribe un mensaje",
  "00fcfc375119aa6d": "Detalles adicionales",
  "010926c3ad6a439e": "Eliminar {{removalTotal}} turnos",
  "0148bffc150339a2": "Publicar bloque",
  "017c1e356e1333d8": "Negociación finalizada con éxito con {{workerName}}",
  "01b90521f503d909": "Abre solo a Clipboard",
  "01d786e808b3bcce": "Informes de mala asistencia o conducta poco profesional.",
  "02aa21b190be93e3": "Preparando eliminaciones...",
  "03c78b094b9e6759": "Si su objetivo es quitar a {{workerFirstName}} del turno, puede DNR a {{workerFirstName}}, lo que los desasignará y mantendrá el turno libre para que otros profesionales lo reserven.",
  "04082584f8509cbc": "Se requieren detalles de contacto",
  "04098ef5387aa352": "Nota: el profesional recibirá este mensaje directamente, esto no es interno",
  "0427ec78ba6e5aa9": "Por favor confirme que este profesional fue un No Show.",
  "049245ad1f768a37": "ID del lugar de trabajo",
  "04c8566c6fa2ffdb": "Turno eliminado",
  "04f810b21cc34f3e": "Reportar un incidente de seguridad al equipo de Confianza y Seguridad de Clipboard",
  "050eb4ea88bb108f": "Requisitos de documentación",
  "055881ac6763cba0": "¡Importante!",
  "0690f8319c833581": "Mejorar la probabilidad de cobertura",
  "069d7e9d898e4d81": "ID del trabajador",
  "06c578f913653c48": "Agregar información",
  "06f89d205e418697": "Nuestros datos de ubicación muestran que este profesional aún está en el edificio.",
  "070f06bb8cfc88e9": "Elige una hora antes de que comience el turno.",
  "07548c2c6511d4d1": "Expandir",
  "07555299c4f812c8": "Igual que su oferta; ¿quería aceptar?",
  "0759437ec2b49a2f": "(agregar)",
  "076957bce71fa868": "Enviar pago",
  "08b041935798fbf6": "Usted",
  "08ebafa103c2961e": "Cancelar {{workerFirstName}} y turno",
  "08fd1de4b04df4a2": "Quedarse",
  "08fdcac2f5d9611f": "Por favor describe lo que sucedió.",
  "090b6e496147b1a4": "Ronda {{roundCount}}",
  "09adde92f00886ef": "Registrar entrada",
  "09b864507d1e8cf0": "Por favor selecciona una opción",
  "09f6242266631e82": "Más información",
  "0a360b78d7924ccc": "{{count}} invitaciones caducadas",
  "0a6d0d63ccca9bee": "Error al descargar el horario. Inténtalo de nuevo.",
  "0b65d5e438e4bb47": "Múltiples turnos",
  "0b9447ec7bc5d691": "Turno eliminado",
  "0bfdbd4c5ea7d528": "Esto reserva el turno a {{payRate}}/hr de pago y {{chargeRate}}/hr de cargo. Otras negociaciones abiertas se transferirán a turnos disponibles.",
  "0d7e412d40f505a2": "Abre a Roster y Clipboard de inmediato",
  "0d8cc6461b0c6858": "Profesionales disponibles",
  "0ddf1900b671e408": "Cancelar turno no reservado",
  "0e113a777f41b3a5": "No hay turnos programados",
  "0e91610117029a62": "Actualizar",
  "0f22fde5e0be5cc9": "Acciones del lugar de trabajo",
  "0f7a05f2d2b6420f": "Editar horarios de turno {{slotLabel}} - {{dayLabel}}",
  "0f87f752eb57eac2": "Opciones de respuesta rápida",
  "0fe556b25edd844f": "Inmediatamente",
  "10252e02c5f434c1": "{{shiftCount}} turno futuro reservado",
  "1028b375c3e16096": "¿Quieres",
  "102942783e52049d": "Filtrar tipos de turno",
  "1060c7e27852f3f2": "Ver candidatos",
  "1071668ed0a4e232": "Hay un turno no reservado en la misma franja horaria. ¿Qué te gustaría hacer?",
  "10b724964a717d29": "Modo de agregar turnos",
  "10fe0cb9a1d28fb1": "Turno abierto",
  "1196833af5d37690": "¿Salir del chat?",
  "119a718f0a036cbe": "Cancelar bloque",
  "11a6767d5674c7e4": "Hecho",
  "11d1eaa116c5ddcb": "Si necesita ayuda, llame a operaciones al {{supportTelephone}} o",
  "12129eebb9eb8b03": "Esperando respuesta",
  "1246fc93bca00b90": "Fijo",
  "12762ab2d798a9b9": "Agrega una nota sobre esta eliminación",
  "127c043502a4a52d": "Información de tipos de profesionales",
  "12bc86b0c3ae7b6b": "Seleccione un rol y una fecha para elegir a un profesional.",
  "1367a2d916565114": "No se pudo eliminar {{failed}} turno",
  "13b9a1e9544a18b9": "¿Cuándo debe abrirse este turno en Clipboard?",
  "14736a2eb9f4159f": "Rol",
  "148304483abafc6a": "NOC",
  "1509f561f2416598": "Guardar",
  "159c9a4771cb8656": "Mantener cobertura durante la tormenta invernal",
  "15f9bd7ac18aacd0": "Razón para la eliminación",
  "1610dcd8f5e4eb1d": "Error al descargar las hojas de tiempo",
  "164e553118ec7fec": "Clipboard prohíbe la discriminación basada en el género. Al continuar, confirmas que este requisito de género es necesario para cumplir con la privacidad o necesidades personales de los beneficiarios del servicio, de acuerdo con nuestra",
  "16bb19636737e5ff": "Puedes enviarle a {{workerName}} comentarios constructivos para ayudarle a mejorar en lugar de bloquearle.",
  "172f70e865600bcb": "tarifa de {{feeAmount}}",
  "17303837a7538dd9": "No se han agregado turnos aún",
  "1737c4c244195b71": "Cancelar turno",
  "17c621b6accdc780": "Error al enviar.",
  "17c8d95161a70ad9": "Salir de la publicación masiva",
  "17e28e2302175d33": "Cerrar barra lateral",
  "186022c788ea6060": "Razón de cancelación",
  "18b5c627fdd66dff": "Acción necesaria: Su contrato requiere una firma para evitar interrupciones en el servicio.",
  "19766ed6ccb2f4a3": "Cancelar",
  "19a7c78d921f0ddf": "Detalles de la ventana de Roster",
  "19aa8a3468d17bc7": "el trabajador",
  "19aafeafb4adfec9": "Función de Cargo Variable deshabilitada.",
  "19c73a5cdf346d96": "Profesional",
  "19dcad6dea244c2e": "Buscar profesionales...",
  "19faf265a62c6297": "Este turno fue cancelado",
  "1a0f5183da04119b": "Cargando detalles de la cancelación...",
  "1a53ecdf6e5b2bfb": "El trabajador recibe {{amount}}",
  "1aa7434e840e2e6f": "O seleccione un espacio en el calendario para agregar un turno",
  "1ac3ed11b0cc74bf": "Informe de incidente enviado",
  "1adcf08dfb9aae9e": "Cargo Variable deshabilitado",
  "1b015904cc17649e": "Urgente",
  "1b68f8d369e5720d": "Aumentar bono",
  "1b7f5c5612251b7e": "Solo Roster hasta {{date}}",
  "1bf3bb986c8f9da0": "Publicar como turno abierto",
  "1bf94bc3f4fcb496": "Pida a un administrador o tomador de decisiones corporativo que habilite el Cargo Variable para su lugar de trabajo.",
  "1c88343383eec30e": "{{count}} profesional disponible",
  "1cbd9e713d937bad": "Proponer",
  "1cf9868356849393": "No hay turnos programados para este día",
  "1dbe776f8df153b6": "por cancelar este turno ocupado menos de",
  "1de82c89364987c9": "Selecciona las fechas de los turnos para tu bloque",
  "1e06ac23b9c0ef5b": "No se encontraron profesionales que coincidan con su búsqueda.",
  "1e6f33ef90a1b9e4": "No le cobraremos más que la tarifa que ingresó.",
  "1e7a2f6e8859d410": "No se pudieron eliminar {{failed}} turnos",
  "1ef1ab0d0f5450eb": "la tormenta invernal",
  "1f5bb9791a310e13": "ocultar",
  "1f6738ae6725e558": "Extender la disponibilidad",
  "1fc9a387654d410f": "Seleccionar todo",
  "1fd9ae1607aa3d80": "Invitar",
  "1ff57a29d7c9d11b": "Siguiente",
  "204c32396d64a8af": "Cobertura de Tormenta Invernal",
  "2057a5d5682b3170": "Error al fichar",
  "20591572c69c1b4e": "Bono fijo eliminado",
  "2065214198dca65c": "Haga clic en el + en un turno próximo para agregar un turno.",
  "20fe1bd201cd900b": "Hombre",
  "211d0bb8cf4f5b52": "Bloquear",
  "217021c7d2c357c9": "Usar Agente de Programación",
  "21821f4dd188bf0b": "Confirma la tarifa por cancelación tardía para continuar",
  "21b111cbfe6e8fca": "Por defecto",
  "21edde0b34ffe68f": "Describa lo que ocurrió",
  "2258357aa643188e": "Eliminar incentivo",
  "22ae3ae1b8f20bc7": "No se pudo enviar la invitación",
  "22e23069cd4a05cb": "Compartir ahora",
  "22e56381a7a2679d": "Cerrar detalles del turno",
  "231d5ad2f40c41b6": "Todos los turnos futuros después de {{suspensionDate}} están cancelados y no puede publicar nuevos turnos. Comuníquese con el soporte para obtener ayuda.",
  "23bbca4c71300543": "para obtener ayuda.",
  "23fa2712b869a919": "Advertencia de asistencia",
  "24331847f1d79bdf": "Publicar un nuevo turno de {{qualificationDisplayName}}",
  "24b7bdf3f774ecd8": "Algunos turnos en espera están en el pasado.",
  "2502bbd1f2c52382": "Error al abrir este turno a Clipboard. Por favor, inténtalo de nuevo.",
  "255381b98af5d088": "Por favor revise y firme su",
  "257c8051763d5f71": "Compartir credenciales",
  "259f577df539d7cd": "Próxima fecha",
  "25a30cd36d986509": "Hay un turno no reservado ({{qualification}}, {{unbookedTimeRange}}) en la misma franja horaria que {{workerFirstName}} ({{qualification}}, {{bookedTimeRange}}).",
  "25a665e3b1181d73": "Actualmente se requiere antes de reservar",
  "260eae735d6581d7": "Revise y firme nuestro contrato para que pueda comenzar a publicar turnos.",
  "2636a1e1a4daa771": "Mantener prioridad en la lista",
  "2697224aca1d4116": "El equipo de Confianza y Seguridad puede necesitar comunicarse para obtener información adicional, por favor proporcione el nombre y el número de teléfono de la persona con la que sería mejor hablar sobre este asunto.",
  "273a586f155caa70": "Habilitar precios inteligentes",
  "276773067bcc2280": "Nombre y número de teléfono",
  "27f4beaf2d0c3765": "Este turno no puede ser publicado porque su hora de inicio ya ha pasado.",
  "2800c84cd7149ab9": "Abre tanto a tus profesionales de la planificación como a los de Clipboard",
  "2831c2ddc70ba1ad": "¿Desea continuar con la publicación de este turno?",
  "28fa073686270307": "Parte de un bloque de {{shiftCount}} turnos",
  "29a390f9237e3c84": "Eliminar todo",
  "2a817149e3aeea86": "Su cuenta está pendiente debido a facturas vencidas. Las cuentas pendientes no pueden cubrir más turnos, pero los turnos que ya están cubiertos no se verán afectados.",
  "2ad09f56e2331223": "Tarifa aumentada",
  "2b065c7c9ce466e5": "Hoy",
  "2b7d8d67147ad7cf": "Último turno: {{lastShiftDate}}",
  "2b90bd98983c5a81": "Turno de lista: sin tarifa de cancelación",
  "2c9ae8e4cf7e2d3d": "Esto está por encima de su oferta",
  "2ca0beb5c205fd55": "Esta opción está seleccionada por defecto para maximizar sus posibilidades de cubrir el turno.",
  "2d1f9e0d071255c9": "Estos horarios se convierten en el predeterminado para {{qualification}} en la publicación masiva mensual y la superficie de publicación diaria.",
  "2d74b9c80eb0770e": "{{rateDifference}} por encima de la tarifa publicada",
  "2d88a3a2842eb3c9": "Do",
  "2d88b01c3fb29b61": "Total {{totalCharge}}/hr",
  "2dc9bc64d8899540": "{{slotLabel}} turnos, {{filledCount}} llenos de {{totalCount}}, el intervalo de tiempo ha pasado",
  "2e218ce6e44faf2c": "Está a punto de publicar {{additionTotal}} turnos de {{qualificationLabel}}.",
  "2e46006a5eebb262": "Hora de finalización",
  "2e544a292f6979ed": "Turno",
  "2e811ac7cc6b5daa": "Profesionales recientes",
  "2f0114c6e138bd7e": "Cerrar registro de turno",
  "2f3a0951c5962882": "Tipo de turno",
  "2f3ad8a786e16944": "Buscando un reemplazo...",
  "2f51b30db4cd1176": "Precios inteligentes",
  "2f5354e56825ae7f": "Salir de la publicación por bloque",
  "2f58e1382535f4d7": "No, esto es solo una solicitud de No Regresar",
  "2f785dc1b9e86608": "{{count}} nuevos profesionales necesitan credenciales de {{credentialsType}}",
  "3095ee946570a186": "Abrir vista diaria para {{dateLabel}}",
  "30c80016cf2cca67": "Acción necesaria: asegúrese de que los detalles de su contrato estén actualizados para el {{deadline}}",
  "30f7b875a0165505": "Turno cancelado",
  "310ca503ef36f177": "Mes",
  "3140100df131cf30": "Masivo",
  "3151c8d8f3418084": ". Si no es así, por favor reenvíe este enlace a la persona en su organización que debe firmar.",
  "3169d6942414f3b0": "Uso de cuenta temporalmente pausado",
  "31eaff37b666d873": "Mostrar solo {{label}}",
  "31fbef162594de01": "Continuar",
  "324a91e31f9f93d7": "Esto cancelará tanto el turno como a {{workerFirstName}}.",
  "326518a87a39b868": "Gestionar aumento",
  "329824d70f5d0cb1": "Nuevo en su lugar de trabajo",
  "32f665851af6351c": "Agrega cualquier información adicional que quieras compartir con el profesional sobre este bloque.",
  "33b93476cf597a33": "Hora",
  "3488b995b0dd3405": "Aumentar las tarifas te ayuda a cubrir rápidamente tus turnos más críticos.",
  "3499752d53797ff5": "Por favor, seleccione al menos una razón",
  "34faa79524f1d62d": "(opcional) Enviar una nota ",
  "3524eba34999f164": "Estás viendo este banner porque los detalles clave de tu contrato necesitan ser verificados. Para evitar interrupciones, por favor discute esto con nuestro equipo antes de {{deadline}}.",
  "355a68d4614fc7f9": "Tu cuenta está suspendida",
  "35acb87b3b3529db": "Publicación masiva",
  "35cba9c5c215f74b": "Turno cancelado",
  "35d8b67a2ad1bde9": "Solicita un aumento de límite para continuar programando para esta semana.",
  "3617bd6b5a419818": "Tipo de profesional",
  "36ac4b709817ee04": "Solo mujeres",
  "36b67fc35f565beb": "Publicar {{additionTotal}} y eliminar {{removalTotal}}",
  "370c0a0b15a21184": "Importante: Informe a los llamadores de la instalación que los turnos no pueden ser publicados por usuarios de Clipboard, o dentro de Clipboard y deben ser publicados solo en Staff Lion.",
  "3778a9b61578a0d5": "Error al agregar al profesional a la lista de No Devolver.",
  "38a99ec1b1d35732": "Tu cuenta está pendiente",
  "390dd9f6966d7e83": "Guardar y cerrar",
  "3978a81d56856530": "Mostrar tarifa de cargo",
  "39df2b7d1662cfc2": "Aplicar ({{count}})",
  "3a38aa141f8de7b9": "Unidad de ventana de prioridad",
  "3a962c2d16deec6e": "Aplicando cambios",
  "3afdff69010a1a2f": "¿Dar una segunda oportunidad al profesional?",
  "3b52447110e6549a": "Restablecer todos los turnos de {{shiftGroup}}",
  "3bed1cee17430c84": "Error al actualizar el bono",
  "3bff939c10f4d9bc": "Ju",
  "3c9870f44b458bee": "Empieza a las {{time}} el {{day}}",
  "3c9d9544c83915b4": "Crear un bloque de turnos",
  "3ca15ca441e1a3db": "{{hours}} horas",
  "3ccd9d6586ef9143": "Algo salió mal. Por favor, inténtelo de nuevo.",
  "3ce2791bc098fe1f": "Estos documentos pueden estar bloqueando a profesionales cercanos para que reserven tus turnos.",
  "3d0b55c963bda776": "Error al eliminar al trabajador de la lista DNR",
  "3d1b86d01a167687": "Cuenta pendiente",
  "3e5616600c45579f": "Eliminando turnos... ({{removed}}/{{totalToRemove}})",
  "3e6983428ed0aa6c": "Colapsar progreso de llenado",
  "3ec90c0349b2f97b": "Estos documentos están bloqueando a profesionales cercanos que podrían estar interesados en tus turnos.",
  "3f59dc327ce6b766": "Agrega cualquier contexto adicional (por ejemplo, el mejor número de teléfono para contactarte)",
  "3f84c2bf421a83d0": "este tipo de trabajador",
  "3fb9316bd977b9ff": "Registro de turnos",
  "407fd659c6c7c9c7": "Eliminar turno",
  "408883a67ad617ca": "Turno no reservado cancelado. {{workerFirstName}} sigue programado.",
  "40b70bd43b31ecbb": "Habilita el Cargo Variable para fomentar que los profesionales de salud reserven turnos durante {{eventName}}. Una vez habilitado, puedes editar las tarifas directamente desde las acciones del turno.",
  "4126fadbb792958c": "No se encontró ningún personal coincidente.",
  "4127d13bb9dac63a": "¿Puedes contarnos qué pasó?",
  "414fdb23cbd5f38e": "de una sesión anterior. Continúa donde lo dejaste, o comienza de nuevo publicando",
  "4161e0b718d06dfc": "Tiempos de turno actualizados",
  "420eea4285ed241f": "Abrir el filtro de calificaciones",
  "4375644cd8a073a8": "No show detectado, reemplazado",
  "439c9e0014d79dcb": "Esperado {{time}}",
  "43a5ef392d3452ea": "Nuevo turno de {{qualification}}",
  "43def83c3447de5e": "Seleccionar una fecha",
  "43e2e6af44325a1b": "Proporciona información adicional sobre tu lugar de trabajo para aumentar las posibilidades de cubrir tus turnos.",
  "4465be0af1a9e4b3": "¿Finalizar negociación con {{workerName}}?",
  "44936a2ec05fa2f5": "Busque un profesional para invitar.",
  "450538c1602e67c7": "Cerrar agregar turnos",
  "457912b220fcfaf5": "Todos ocupados",
  "460b3a7da007b7af": "Chat",
  "464c4ffd019e1e96": "Editar",
  "46586575deed6e93": "{{workerName}} ha sido agregado a la lista de No Retornar",
  "465e891b9fe6509d": "Mantener turno",
  "46a81739c6ee7c1d": "acuerdo",
  "46b70ac20134bbd7": "Historial de negociación ({{proposalCount}} propuestas)",
  "47181cce0990730f": ". ¿Cuánto tiempo deben poder reservar los profesionales este turno?",
  "472c6c914210d3d9": "Ver hoja de tiempo",
  "476a390901962a87": "Publicar un nuevo turno de {{timeSlot}} {{qualification}}",
  "4774eebd95c6b9a8": "Total de nuevos turnos:",
  "4796d436b7eec305": "Has alcanzado tu límite semanal aprobado y no puedes publicar más turnos. Por favor, contacta a tu gerente de cuenta, representante de facturación, o billing@clipboardhealth.com para asistencia.",
  "479a09de0db06ffb": "Revisar ahora",
  "4850b174b713d88c": "Requerido",
  "48d1d231845ef108": " máximo",
  "4a0df895879bfb77": "Reserva al mismo profesional por días consecutivos como un bloque de todo o nada.",
  "4a8ac266a8b7f9b3": "Nuevo turno",
  "4afa55bf7aec7ddc": "Términos de servicio",
  "4be6397cfd627ad0": "Bono por hora",
  "4c4ea06708bbe3bb": "El turno se abrirá a Clipboard a las {{time}} el {{date}}",
  "4d573631a40f8ee6": "¡Si llenamos el turno a una tasa más baja, recibirás el ahorro de vuelta! Así de fácil.",
  "4df5cf49afa30308": "Llévame allí",
  "4ed0c8fa6637e0e7": "Detalles del incidente",
  "4f07b5f2af1022e1": "Eliminar turno no cubierto",
  "4f21b405bd6be3b1": "Ingrese la razón para eliminar de la lista DNR...",
  "4f942ae1ac336f51": "La hora de inicio del turno de",
  "50789882cb44cfc0": "Eliminar bloque",
  "50e0901ed332b953": "Dejar de pegar",
  "51617bc0fa10901f": "Tarifa base",
  "51bb47c0de265566": "No, no quiero que se penalice al profesional",
  "524509f2506a2d08": "Modo de vista de calendario",
  "52828dd3cf9a3a8a": "No se pudo actualizar la hora del turno. Por favor, intenta con otra hora o contacta a soporte.",
  "5435c98f684b34df": "Se trabajaron {{shiftCount}} turnos",
  "545aeab0cb25f867": "Invitación expirada",
  "5531037d5744cee1": "Su última oferta",
  "553a4a75b246d634": "Pide a tu administrador de la instalación que agregue o elimine tipos de profesionales",
  "558904acdc18ee4e": "Revisar requisitos",
  "5596ceb702066266": "Se requiere una nota por este motivo",
  "55b6b511e5c3158e": "Haz clic en un espacio del calendario para programar un turno en este bloque. Necesitas al menos dos para publicar.",
  "56885bbb2cfcb446": "Cubre turnos más rápido haciendo que los requisitos de documentos sean opcionales",
  "56aaed0fa4e25a84": "{{count}} invitados",
  "56c775e0ccf199fd": "Desasignar personal de la lista",
  "56f15e2c34e48b3b": "No se puede proponer esta hora de turno",
  "572d42d7e335492c": "Agregar nota del turno",
  "579d6e9360be90bd": "Error al desasignar el personal de la lista. Por favor, inténtelo de nuevo.",
  "58339f45df960408": "Mié",
  "5853a85aef33c6b2": "Copiar turnos de {{dateLabel}}",
  "5948473cb85291e6": "Activar/desactivar respaldos",
  "59be71333c960fd0": "Opcional",
  "59bee529e6a259c3": "Aumentar tarifa",
  "59ebe97eedd6795e": "Editar hora",
  "5a365d43779e1354": "Contactar a Clipboard",
  "5aa786bd3cbe7854": "Agrega o elimina al menos un turno antes de enviar",
  "5ac70032199b6599": "Comentarios enviados",
  "5ad1562de87b82a2": "Tiene turnos activos en las próximas 2 semanas",
  "5ad3dbd1242a4cea": "Entendido",
  "5ae266fd755ca628": "Tu cuenta está actualmente pendiente",
  "5b27cf835a3345d0": "No hay turnos para exportar para este día.",
  "5bbd271ed5b84a80": "Turnos en bloque",
  "5c3967e73c04beef": "Mujer",
  "5c78570dfc24ed1f": "Cambia cualquier requisito a opcional y actualizaremos los requisitos de documentos de tu lugar de trabajo.",
  "5d89dc684f609de3": "{{count}} turno cancelado",
  "5da7346b9142aee1": "Se requieren detalles del incidente",
  "5dae5aaadc38d39c": "Redactando turnos",
  "5db5ce1b1688c4bc": "Cuando no está marcado:",
  "5dd0686817487f6c": "DNR {{workerFirstName}}",
  "5e1518bc8f5b7460": "Eliminar turnos de {{slotLabel}} el {{dateLabel}}",
  "5e40f803e47d6624": "la próxima tormenta invernal",
  "5e6bda48493c209d": "Si el profesional invitado no acepta el turno dentro del tiempo de expiración de la invitación, el turno se publicará automáticamente en el mercado como un turno abierto para que otros profesionales calificados lo reclamen.",
  "5e8f2802c5edc572": "por cancelar este turno cubierto menos de",
  "5eed7e9fc8f3cd68": "Comenzar de nuevo",
  "5fc0b4a20d784166": "Entiendo que se me cobrará un",
  "5fd5a28429682f05": "Cargo por envío a casa",
  "5ffcf02ce5a74f9e": "Reservable hasta: {{time}}",
  "600dc26d055ac98a": "{{count}} profesionales disponibles",
  "604bb026660c00eb": "No se pudo eliminar el bloque de turnos. Por favor intenta nuevamente.",
  "60d77ad375d1ac84": "Deja que el programador maneje el resto",
  "61088da4a61587a7": "Error al actualizar los tipos de turno. Comuníquese con el soporte de Clipboard Health si este problema persiste.",
  "61bc3def3d4deedd": "{{count}} invitaciones rechazadas",
  "61f4fb5b61e0a8fd": "Agregar una nota sobre esta cancelación",
  "624c1c4ae0e337d5": "Franja horaria no disponible",
  "625371f4e73cdb4b": "Enviar comentarios a {{workerName}}",
  "6267e14405aeca2b": "El profesional recibe",
  "6269327f267ba795": "Solicitudes de hojas de tiempo pendientes de revisión",
  "6269e24f31555003": "Bloque de turnos",
  "627bfc3844c6d390": "{{removed}} turnos eliminados",
  "628168cad5b898b0": "¿Está seguro de que desea retirar a su personal de Roster, {{name}}, de este turno? Esto volverá a abrir el turno al resto de su Roster y a Clipboard de acuerdo con las ventanas de Roster con las que se publicó el turno.",
  "62afcc74654de6ab": "Ma",
  "637f3650adbaa3d7": "{{amount}} Impulso",
  "63902b91749dd1cd": "Esto los desasignará pero mantendrá el turno abierto para que otros profesionales lo reserven.",
  "63b3b86b1a73ea44": "No hay turnos borrador aún.",
  "63dceb8800b2dd4a": "Teléfono",
  "6439ad295bda456e": "No se han agregado turnos",
  "6449dfdbe24d2762": "Múltiples invitaciones",
  "646662c9cc44caf4": "Cobertura de fin de semana del Día de los Caídos",
  "648ee100798ed22c": "¿Cancelar bloque?",
  "64b66898bb10ed0e": "72 horas después de la suspensión",
  "65659145569b894b": "Aviso",
  "65b05e85db8eb9ce": "Turnos de {{slotLabel}}, vacíos",
  "661527e0f00a0bc6": "Exportando su horario...",
  "6615bf1c8fddf2fb": "Ocurrió un error inesperado",
  "66dab40cea1dea5c": "Vie",
  "67132f11ff8ff152": "Tu turno no fue agregado",
  "675781c7c0e04437": "No hay turnos programados aún",
  "6779d4437e8097e0": "Buscar personal...",
  "67a1f8442ee4a6a7": "Historial de negociación ({{proposalCount}} propuesta)",
  "6952ce3ec3574335": "Publicación por bloque",
  "69774c6c1c99615a": "Error al actualizar los tiempos de los turnos",
  "6a2769502a5dda78": "Mes anterior",
  "6a47708f4e14c122": "Revisar cambios",
  "6aadac2f2b7a6b8e": "Regresar",
  "6b85d437dab6a01d": "Cancelar turno",
  "6b90bc9c4208233d": "Por favor selecciona a otro profesional para invitar.",
  "6b987654a4116384": "PM",
  "6ba7ed94943d0b33": "Los profesionales pueden reservar sin este documento",
  "6c7b0e7ddfb18671": "Marcado a las {{time}}",
  "6cb93237b9deea9e": "¿Dejar publicación?",
  "6cca5d22536aef55": "¿Turnos {{qualificationLabel}}?",
  "6cfa6d04526e5a93": "Su lugar de trabajo no cobrará una tarifa de cancelación por cancelar este turno.",
  "6d18fcf56e18907d": "Editar tipos de turno",
  "6d320a315fe443f9": "Hoja de tiempo",
  "6dc6e21727fb5327": "Este turno fue cancelado ($)",
  "6e2fdeeae10320d8": "Buscando turnos",
  "6f21f336aa5f9f6a": "Su última oferta",
  "6f92dd1d3de72e35": "ID del bloque:",
  "701c76afce2dc9f5": "No se pudo aceptar la negociación. Por favor, inténtalo de nuevo.",
  "703390318bd55aef": "Beta",
  "7038572cdeb56103": "Notas para profesionales",
  "70e88997202f3fe7": "Eliminar turno de lista",
  "712da63171e0c9de": "Desbloquear",
  "71586829d065e40f": "Emitir una advertencia",
  "7173e79ec9298b9d": "&middot;",
  "7175517a370b5cd2": "o",
  "7186640a4e92c7ad": "por el tiempo de este profesional.",
  "71c6639e24d817f0": "Parte de un bloque de turnos",
  "71cdc6fd708a4ed2": "Cambiar vista",
  "72058919d1f2d512": "¿DNR {{workerFirstName}} y desasignar del turno?",
  "7229bffa105473fa": "Cerrar panel diario",
  "72ff542bf8a7669f": "No se pudo copiar al portapapeles",
  "734b78d362d60f63": " — {{time}} el {{day}}. Hasta entonces, solo tu planificación puede reservar.",
  "7450add02db5e174": "¿Prefieres discutir los documentos requeridos?",
  "745fc5be2efa1531": "Seleccionar tipo de turno",
  "74a58af4a2da23e0": "Se aplica una tarifa de urgencia",
  "74cde7a4ea38225f": "No se pueden cargar los registros de turnos",
  "74e53211fef4b4d4": "Próximo mes",
  "74fd12fee729a47d": "Estás a punto de eliminar {{removalTotal}} turnos de {{qualificationLabel}}.",
  "751c15306765d550": "aceptar solicitud de reserva",
  "75c298c733082225": "Seleccionar otro profesional",
  "75d83f7682f56a52": "Ir a hoy",
  "7623ef2414ccf9ec": "Tienes {{count}} solicitudes pendientes esperando tu aprobación.",
  "76319028bb672ced": "Seleccione las razones para DNR:",
  "763d720d368de2e9": "No se pudo actualizar la hora de este turno",
  "7661cdeaf93ba1a4": "Este turno será cancelado.",
  "76900f1bfd16c8d4": "Regresar",
  "76a13f805cdc1b8b": "Enviar invitación",
  "76eff1e784e83cf5": "Error al cargar la hoja de horas",
  "76f69e45c2791d57": "este trabajador",
  "77a562b657da74bf": "una tarifa",
  "77df31107c9cd6a2": "Habilitar reserva por bloque",
  "77e358417e9b5bd9": "Extender el período de reserva",
  "79415acaf556f49e": "Trabajó {{shiftCount}} turno",
  "796be7af1a22b31c": "Este profesional no puede recibir esta invitación. Por favor, revise los problemas a continuación.",
  "799740596bd4c378": "Pegar turnos en {{dateLabel}}",
  "79a9d7d5e52b144a": "Profesionales destacados",
  "7af129ac87e6c3fb": "Eliminar un turno de {{slotLabel}} el {{dateLabel}}",
  "7b05e32e8323fa92": "Invitado:",
  "7b4339cf860e01a6": "Calificaciones",
  "7bb59e6f16e56dda": "¿Estás seguro de que deseas cancelar este bloque de {{shiftCount}} turnos desde {{dateRange}}?",
  "7bf1d1ae493c65f4": "¿Desea continuar con el envío de esta invitación?",
  "7c94eda094c800ff": "{{hours}} hora",
  "7cb0b1ba74933007": "¿Reservar a {{workerName}} para este turno?",
  "7cb1dcb673d3dcc9": "{{shiftCount}} turnos",
  "7d0bd0942884cd45": "Finalizar el registro",
  "7d1e234cd60235a4": "Tarifa urgente",
  "7d5208aa55606653": "Abrir a Clipboard ahora",
  "7d9d83e30ac123f3": "¿Cómo desea aplicar este cambio de tiempo?",
  "7d9eb7acb13e2462": "Cerrar",
  "7da11212ed340ea7": "Jue",
  "7ddacf9693938efc": "Turno de {{qualification}}",
  "7e05c585ff758063": "Usaremos nuestros algoritmos de precios de clase mundial para encontrarte un profesional a la tarifa más baja posible.",
  "7e16ac00450dfbef": "Mostrar más tipos de turnos",
  "7e271cc38a9f2950": "Proponer una nueva hora de turno",
  "7e6fefff0f0aeb6c": "Oculto",
  "7e95d39fd43fb729": "Publicar turnos con tarifa urgente",
  "7ed1f0d4b2b0faeb": "Publicar un nuevo turno de {{timeSlot}}",
  "7fc5eb1dfd5320ef": "Este turno comienza pronto a las",
  "802ab5569606ed0d": "Error al crear el bloque",
  "80bb74682ba302ea": "Tiene turnos en cola para publicación masiva",
  "80f5498e5eab1fe5": "Más opciones de publicación",
  "813dbaacd7d32e4a": "Actualmente en la lista de No retornar",
  "814f4ed2d5bd33e3": "Contactar soporte",
  "8169693101a4536c": "Fecha de inicio",
  "81b43c68e7a45f2d": "¿Dar otra oportunidad al profesional? Emitir una advertencia en lugar de un DNR",
  "822bab8d41bca8d7": "Cantidad",
  "8235980b80addfc7": "Enviar comentarios",
  "82d1af9a1ba4f3ad": "Todos los {{totalShifts}} ocupados",
  "82fc2d12a96f469a": "Nota: Los trabajadores de nómina no tienen tarifas y no verán ni recibirán cambios en las tarifas.",
  "83221ab96f11b0cf": "Los profesionales de cualquier género podrán ver los nuevos turnos que publiques. Esto no afectará a los turnos que ya has publicado.",
  "832c49d5487a2b06": "Habilitar reserva instantánea",
  "833b4c5ff49767b7": "directamente al profesional",
  "837e8d24e44d8288": "Publicar turno con tarifa de urgencia",
  "83a03d5fe0e91d5a": "Añadiendo turnos de {{qualificationLabel}}",
  "849d7b529c20c7f4": "Publicar como turno abierto si se rechaza",
  "84b00ba36056eea9": "El profesional se va sin mi permiso.",
  "8628e564d722308d": ". Hasta entonces, solo tu planificación puede reservar.",
  "86a3835bd36c3318": "Propuesta de tarifa enviada exitosamente",
  "86f4050aa4cd9953": "Bloque de turno",
  "8734ab3e91d7adb4": "No se pudo actualizar la tarifa de carga",
  "873567be309f124e": "Continuar de todos modos",
  "8795fb4cfe8a7f38": "contactar soporte en línea",
  "879d8fb64f88733e": "Solo",
  "87fbe4fb79b1d700": "Adjuntar archivo",
  "8850a960f4e7675d": "Propuestas de tarifas ({{proposalCount}})",
  "8918efd027c62b04": "Incrementar tarifa",
  "89713b9c9c1b8f65": "Aceptar",
  "897a71d5318d675b": "Cargando turnos...",
  "89bf5c6461335cb0": "Garantía de llenado aplicada",
  "8a61b9ed2af8095b": "Tienes 1 solicitud pendiente esperando tu aprobación.",
  "8a9de5c92e68f67c": "Reemplazando...",
  "8ad5acfe0b6db645": "Invitación rechazada",
  "8b045ff0baac5c19": "Solicitudes pendientes para reservar",
  "8b143481ef6d18ac": "Monto del bono",
  "8bb5c11f9e2c57a9": "Cualquier profesional calificado puede reservar",
  "8ce311a77e2d0755": "No hay registros de turnos aún",
  "8d3085ef72407e54": "Guardando ",
  "8d525e5f158b9afe": "Copiado",
  "8d5b9323d5e35205": "{{workerName}} ha trabajado {{shiftCount}} turnos en {{workplaceName}}. Considera enviar comentarios constructivos para ayudarle a mejorar en lugar de bloquearle.",
  "8d75f799b447a218": "Cerrar cajón de invitaciones",
  "8d8c27652b244dfe": "Propuestas de tarifas pendientes",
  "8dd52892f76fe969": "{{count}} fecha seleccionada",
  "8de7fac328e8be53": "{{count}} turnos cancelados",
  "8e27a3ae187f2af8": " antes del inicio del turno. Establece una hora anterior para dar más tiempo a los profesionales para reservar.",
  "8e36307961c6d5c1": "{{count}} Turnos",
  "8ebd5b705d7e64d2": "Tipo de incentivo",
  "8f2364e11b8be3ff": "Día",
  "8fbb370cbd171142": "Usa el botón + en un espacio de calendario para añadir turnos. Aparecerán aquí agrupados por día.",
  "909cb81127c5e194": "Reservar",
  "911f369d5d37788c": "Bono prorrateado por aumento",
  "91d6c413d45572ff": "o describe tus turnos a continuación",
  "91f7609e000bb439": "{{days}} días antes del inicio del turno",
  "924ef415081790aa": "Modo de publicación",
  "92760e47580947ab": "Tu chat con el agente se reiniciará si sales, pero los turnos en borrador permanecerán guardados.",
  "929bbe292fcd5071": "Este profesional no puede recibir esta invitación.",
  "92aa4b51d483db30": " de su ",
  "92f5e0bdde0f12fb": "Tu cuenta será suspendida debido a pagos pendientes",
  "930ca66d1a74fc9d": "Debe tener al menos {{minLength}} caracteres",
  "938220cf22b2c66e": "breakPolicies requiereLunchBreak",
  "93b41151c11932da": "Haz clic en un espacio para comenzar",
  "93e76940cf397ea3": "Editar ventana de planificación para este turno",
  "942087cc2d41e013": "Reintentar",
  "94cf88d91055c26a": "No se cobrará a su lugar de trabajo una tarifa de cancelación por cancelar este turno.",
  "94db8329fecc5718": "Todos los turnos futuros del bloque de turnos han sido eliminados",
  "958020550633c6c7": "No se pudo actualizar la nota del turno",
  "95836f82062da8db": "Mostrar menos tipos de turnos",
  "9593eab7fed12fc4": "¿Ya no necesita cobertura para este turno?",
  "95e445f6311803b9": "Todos los turnos",
  "95f7a41f508314ad": "Otros profesionales",
  "963a5fc0081a9f94": "Al menos un tipo de trabajador debe ser visible.",
  "964b67c944a13ef9": "Ver contrato",
  "9669ede056b7aa5f": "Este mensaje será enviado directamente al profesional a través del chat. Esta acción no se puede deshacer.",
  "9681395de456c72b": "Detalles de contacto",
  "968e3c7a50310a66": "{{count}} Turno",
  "969ccbd3cf6300ec": "Correo electrónico",
  "96b562d99d00fdab": "No hay turnos en este día",
  "97112eb82d331ca8": "(opcional) Envía una nota directamente al profesional sobre la cancelación",
  "974af971aadee8b9": "Propones {{payRate}}/hr",
  "977844fd4358f110": "Seleccionar un rol",
  "9841ea515c1c0ae1": "ver documentos del trabajador",
  "9872a19ccc59e398": "Estás a punto de publicar {{additionTotal}} y eliminar {{removalTotal}} turnos de {{qualificationLabel}}.",
  "98917ffe0f77381a": "Error al enviar la propuesta. Inténtalo de nuevo.",
  "98965ca31b020f81": "Publicando turnos",
  "98b907a974c7e66f": "Este turno comienza pronto",
  "99810648bc14cd3b": "No se solicitó reemplazo",
  "99c40ab405926cb5": "Fecha",
  "9a7b8a4e1d434df4": "Seleccionar {{date}}, hoy",
  "9af8ecb103b1dcf4": "Tarifa de Clipboard",
  "9bee0cca8c8afc57": "Editar horarios del turno de {{slotLabel}} el {{dateLabel}}",
  "9c7502853539b248": "Reducir tarifa",
  "9cbf17bb0535e1ff": "El turno seguirá disponible para que otros profesionales calificados lo tomen hasta que se cubra o expire.",
  "9cd196d90bf55de2": "Un profesional reserva un bloque entero",
  "9cd54a598bb5a987": "Cargo por cancelación tardía",
  "9cf43b59441404fb": "No se puede finalizar la negociación. Por favor, inténtalo de nuevo.",
  "9da8797fa5a6cb02": "No, bloquear de todas formas",
  "9db29e4b9988dc6f": "Añadir múltiples turnos",
  "9dc63df81e577b4f": "Busque un trabajador de Roster para asignar.",
  "9e8197ce9e5f9592": "Mostrar barra lateral",
  "9ec09d9fdf3dd405": "Eliminar turno de {{slotLabel}} del bloque",
  "9ec49dbdc7bdcabf": "Estos horarios se aplican a cada turno programado para este espacio de {{slotLabel}} el {{dayLabel}}. Otros días utilizan la configuración predeterminada del lugar de trabajo.",
  "9ef3ca2074b88e30": "Bono fijo aplicado con éxito",
  "9f48f1c96fafcc8a": "Añadir un turno de {{slotLabel}} el {{dateLabel}}",
  "9fd728c66c9a256b": "Agregar",
  "a045379eaab1e76a": "La función de Solicitud de Marcación Perdida NO está activa para este lugar de trabajo. Utilice la herramienta de verificación de turnos para verificar los turnos.",
  "a08c01726fe761a1": "Documentos faltantes:",
  "a0cdf03cc74c5033": "No se presentó, reemplazando...",
  "a0dcca719b0b6692": "Eliminar turno de {{slotLabel}}",
  "a0e63d7c7125d29a": "No ahora",
  "a110c8bf63a88829": "¿Enviar comentarios en su lugar?",
  "a21114e9cf645f9c": "Selecciona turnos para el bloque",
  "a22f7d394ae4188b": "Base {{baseCharge}} · Pago +{{payDelta}} · Cargo +{{chargeDelta}} →",
  "a2b280cfc9dde794": "¿Puedes describir qué sucedió?",
  "a2d285b352873457": "Declinar",
  "a2e7e693ab5bc9c0": "Requerir aprobación para reservar",
  "a411cdc69171bcef": "Tienes facturas vencidas. Si no envías un pago antes del {{pendingDate}}, tu cuenta será bloqueada para cubrir cualquier turno adicional. Cualquier turno que ya esté cubierto no se verá afectado.",
  "a4516904313c6ff4": "Fin de semana del Día de los Caídos",
  "a4814914c30ae9fe": "Error al agregar trabajador a la lista de DNR",
  "a52ace420f2175d0": "Todo",
  "a55076cebaa7f342": "Habilitar Carga Variable para ayudar a cubrir turnos durante {{eventName}}. Puedes editar las tarifas directamente desde las acciones de turnos.",
  "a5554622c655c7a7": "Publicar",
  "a55e892ad25cbf89": "Turno cancelado",
  "a597b36badcfaf6a": "No se pueden cargar los detalles del espacio.",
  "a600b900f83db6cb": "Cerrar panel",
  "a60c0027df397eed": "Solo publique un turno en Clipboard cuando esté absolutamente seguro: esto probablemente romperá la sincronización del turno con el sistema Staff Lion.",
  "a648708bed4aa733": "Pago debido",
  "a657c440f8f62100": "Agregar bono por hora",
  "a67b04cd5c491d4d": "Trabajador",
  "a6fa394a43f903b1": "Gracias por enviar un informe de incidente al equipo de Confianza y Seguridad de Clipboard. Alguien del equipo podría comunicarse contigo por teléfono o correo electrónico.",
  "a7467746c201c0e9": "Cargo total",
  "a857b017bb13651f": "Publicar Turnos",
  "a87abb24997dcec6": "Seleccionar calificación",
  "a93acb02cbaea116": "{{count}} turno",
  "a93bcdae603b8047": "Mejorar este turno",
  "a951efc79deb7ff3": "Sa",
  "a9e590a172099aac": "Habla con alguien de nuestro equipo.",
  "a9faf11e6bd5bec7": "Cancelar invitación al turno",
  "aa0fd4c61d979a91": "{{count}} turnos copiados",
  "aa3e775302e19635": "Ver detalles del bloque de {{shiftCount}} turnos",
  "aa4341053cc3c078": "¿Estás seguro de que deseas eliminar este bloque de {{shiftCount}} turnos desde {{dateRange}}?",
  "aab34f0b19ac7c0a": "Esta propuesta de tiempo de turno puede resultar en que el profesional tenga más de 16.5 horas consecutivas de turnos reservados. ¿Está seguro de que desea proponer este tiempo de turno?",
  "aac77df347205252": "Comentarios",
  "abb3f3a4080a44fb": "No se pudieron cargar los detalles del turno",
  "ac116c1cca856f1a": "Por favor, ingrese al menos {{minLength}} caracteres",
  "ad4d4bd466344f36": "Pide a un administrador que contacte a tu gerente de cuentas o al soporte para habilitar esta función.",
  "aecb793011851118": "Publicar todas las asignaciones",
  "af1515f48822838a": "Editar los horarios de turno de {{slotLabel}}",
  "af3f12e161fdb1cb": "Tienes",
  "afb9da9df3ada8ad": "Se encontraron {{count}} profesionales",
  "afe1c6b53421f9f7": "Restablecer todos los turnos de {{slotLabel}}",
  "aff0766a5290e117": "Revisar",
  "b05be2523b007caa": "Aumentar bonificación por hora",
  "b0641e791fa87d39": "Todavía pueden reservar a la tarifa publicada. Otras negociaciones para este turno permanecen abiertas.",
  "b06fff5032205ff2": "Este turno aún no ha sido publicado ni invitado. ¿Descartar este borrador?",
  "b0a7b3c03119094c": "este turno",
  "b1b5289afe723700": "Solo puedes crear un máximo de {{maximumShiftCount}} turnos a la vez.",
  "b2eb2fd9a90f488b": "para volver a inscribir su cuenta. El estado pendiente significa que no puede aceptar más turnos, pero cualquier turno que ya esté ocupado no se verá afectado. Si no está autorizado para firmar este acuerdo, envíe este enlace a la persona relevante en su organización. Para cualquier pregunta, comuníquese con",
  "b40a57c0c9b17557": "Invitación enviada",
  "b48fd06fbc1b8006": "¿Eliminar bloque?",
  "b4aba91e4f554b31": "Tarifa de cargo",
  "b4ce0fb76e4ef3db": "Bono fijo aplicado a {{count}} sesiones",
  "b4dc66dde806261b": "apagado",
  "b4e929d8bcfe0418": "Documentos",
  "b50e079820bbe89d": "hora de inicio de {{slotLabel}}",
  "b52874990d85754c": "Función de Cargo Variable habilitada. Ahora puede editar tarifas en las tarjetas de turnos.",
  "b578f4df5f37b03f": "Tarifa mínima",
  "b59c75232481974b": "estos {{count}} turnos",
  "b5c120b316c237a0": "Guardado",
  "b6099513e753b3e6": "Incrementar nuevamente",
  "b617615f96e8228c": "Agregar nota interna",
  "b68d849723673e57": "Aceptar tarifa",
  "b749e205302cc219": "Copiar al portapapeles",
  "b753927f1b81553b": "¿Eliminar este turno? Se eliminará de su Roster interno y de Clipboard (si está publicado).",
  "b758a5f34167b9cd": "Fecha de nacimiento",
  "b764cdc0eab71374": "Desconocido",
  "b7c0d007120b9767": "Editar nota del turno",
  "b7f93e7d8bae15f2": "Aplicar este bono a todas las {{shiftCount}} sesiones no cubiertas de {{qualificationName}} desde {{startTime}} hasta {{endTime}}",
  "b82274d4b5cf3655": "{{filledShiftsCount}} de {{totalShifts}} ocupados",
  "b86cab6fac65cc6c": "{{count}} calificaciones seleccionadas",
  "b8c23620ff8c635e": "Sin cargo por cancelación",
  "b8ceb6b8a637aa0b": "1 nuevo profesional necesita credenciales de {{credentialsType}}",
  "b8d31e852725afb1": "encendido",
  "b8e9fce9abb5b491": "Expandir progreso de llenado",
  "b96a6050465ef6df": "Información útil para el profesional (opcional)",
  "b96d5ff6260b4c81": "El bloque se ha creado con éxito",
  "b98884ab0a39304e": "Este turno se abrirá a los profesionales de Clipboard el",
  "b98d1643c4f391bd": "Escribe una nota al profesional...",
  "b9f4177e92b021c2": "Publicaremos un turno urgente y comenzaremos a buscar un profesional de reemplazo. Sin cargo adicional.",
  "bab37d62472990c0": "Ver más",
  "babe9dda85036fe4": "Hora de inicio",
  "bb55bf0aa5b6e211": "No se pueden enviar invitaciones",
  "bb87bbf83341c1b4": "¿Este no regresar involucra un incidente grave de seguridad, clínico, abuso, acoso, robo, deterioro u otro incidente serio de seguridad?",
  "bba4c17d03c1f365": "Se ha alcanzado su límite de uso",
  "bbb0da2768b15762": "Marcado fuera a las {{time}}",
  "bc17b7d2c6a26cbf": "{{postedShiftCount}} de {{totalPendingShifts}} publicados",
  "bc5b45ae7b60692a": "Restablecer a los valores predeterminados",
  "bc79cdffbaa8df09": "Más opciones",
  "bcdb701c2919f1ff": "Aplicar a todos los turnos de {{slotLabel}}",
  "bd4f680faabab58b": "Cancelar invitación",
  "bd59825da9bf173a": "Eliminar el turno de {{slotLabel}} el {{dateLabel}} del bloque",
  "be1e4a39db83f8cc": "{{shiftCount}} turnos futuros reservados",
  "be6eb1fc3b05bf9d": "Colapsar",
  "bf180fbea0d8415e": "El Roster no ha sido actualizado en más de 10 días y puede estar desactualizado",
  "bf46c8950bfc26ca": "Un profesional reserva todos los turnos",
  "bfab8caee6addf35": "Turno abierto para los trabajadores de Clipboard",
  "bfb925ed2f8e4326": "Publicar {{additionTotal}} turnos",
  "bfcd93723edb6e2e": "Agregar turno",
  "bfd5b1e3bd191611": "Establecer esto como mi predeterminado",
  "c0749d7dc469e903": "Desasignar personal de la lista",
  "c088da77a7c4a41f": "El cargo {{totalCharge}}/hr excede {{stateCode}} máximo {{maxCharge}}/hr",
  "c136428eb4f99a17": "Falló al eliminar el turno del roster. Por favor intenta de nuevo.",
  "c1a2763f82ebe0b9": "{{removed}} turno eliminado",
  "c1ad5dcf2e0576ad": "Enviar invitación",
  "c1b116d9c6461f6a": "Falló al actualizar la visibilidad del tipo de trabajador",
  "c1b24f6b30395848": "Solicitar aumento de límite",
  "c1ef7fe3e0d8054c": "Trabajador desconocido",
  "c1f1c8819e337780": "Impulsado",
  "c2d9845f4dbeec1e": "Entiendo que marcar al profesional como No Show resultará en una restricción de cuenta.",
  "c2e06d2bdfe3244f": "Elija qué tipos de profesionales son visibles en el calendario para todos los usuarios en este lugar de trabajo.",
  "c2ff8acd4ad3c7b4": "Algunos turnos comienzan pronto",
  "c335224245004da8": "Tarifa de carga actualizada con éxito",
  "c34d1e939dc17e1c": "Debe tener al menos 20 caracteres",
  "c44d1f7712968552": "{{count}} invitación caducada",
  "c460db5e7ffae1dc": "No se pudo cancelar el bloque de turnos. Por favor intenta nuevamente.",
  "c488a7f2c2b4238d": "Sí, informe esto a Confianza y Seguridad",
  "c51b1b8741a15a40": "No pudimos cargar los detalles del cargo. Por favor, inténtalo de nuevo.",
  "c57456e4427dcf0b": "Enviar invitaciones",
  "c5f0e3e0ade58c8e": "Información sobre precios inteligentes",
  "c60902c99a24da71": "Bono prorrateado",
  "c6a473c0b60eab88": "Cerrar detalles del bloque de turnos",
  "c6e9bec0b2a092db": "{{count}} candidatos están esperando su revisión. Revísalos ahora y elige solicitar una entrevista o rechazar.",
  "c784a48b1fa5dd69": "{{days}} día antes del inicio del turno",
  "c799e3d57799950e": "Se encontró {{count}} profesional",
  "c83fe38303acb6ad": "Llenar en progreso",
  "c8c1b56f18d10c2d": "¿Desea proceder con la publicación de {{subject}}?",
  "c8df66c5fe3f97d0": "Cerrar diálogo",
  "c8f48a68649d1cae": "AM",
  "c97743a83995f818": "Sube tu horario aquí",
  "c9a7e734d5cc5a0d": "Personal asignado al turno",
  "ca2ca4c1f172f1c7": "{{count}} invitación rechazada",
  "ca4153b6bb219647": "Sin cubrir",
  "ca473770db3a6529": "Mantener cobertura durante el fin de semana del Día de los Caídos",
  "cad7947500ea2aaf": "Tarifa de cargo",
  "cadd7bae7f56119d": "Todos los turnos próximos para el bloque de turnos han sido cancelados",
  "cae6753d03d327be": "Este turno ahora estará disponible para ser reclamado por todos los trabajadores de Clipboard. Tu personal de Roster aún tendrá acceso a este turno.",
  "cb35a570b6e4baa6": "Cuenta suspendida",
  "cb86a681fcfaf0da": "No se publicaron turnos de {{timeSlot}}",
  "cc93c1c99d40314f": "Tocar + para publicar un turno",
  "ccaaff90680a3fbe": "Encontraremos un profesional de reemplazo",
  "cd72097a6f69799d": "{{count}} turnos",
  "cdbdac1da505071e": "Enviar invitación con tarifa de urgencia",
  "cdc874b9a974f470": "al mismo tiempo",
  "cdcf0c647f9af9c6": "Opcional: comente a los profesionales cualquier cosa que deban saber.",
  "cdebca45b801e8b2": "Requiere {{serviceTerm}} específico de género",
  "ce48147aa61ee906": "Habilitar acceso prioritario",
  "cea4d2e010b8fd52": "Eliminar selección",
  "ceebd437e1769f44": "No se pueden cargar los conteos mensuales.",
  "cfa969c682dfd6e6": "Error en la publicación masiva",
  "cfb80983bacc8ce9": "Historial de trabajo",
  "cff929e95dd0ab8f": "Alguien del equipo de Clipboard se comunicará dentro de 1 día hábil para revisar los requisitos de documentos de su lugar de trabajo con usted.",
  "d07dd878a6dec3b7": "Ingrese la tarifa",
  "d08a6f77815f3a67": "Agregar turno {{slotLabel}}",
  "d0a4d1e4d6f27b61": "Tipo de turno",
  "d0ec86bc8fd41126": "Cambiar de vista saldrá del modo de publicación. Tus turnos programados se guardan y puedes reanudarlos más tarde.",
  "d11c6831f1ab61dd": "Solo el profesional que invites puede reservar",
  "d17d84a604994b72": "Salir",
  "d1a5968d27cc4b91": "Múltiples turnos",
  "d1aa2cfcd4669bc8": "{{workerName}} ha sido eliminado de la lista de No Volver",
  "d1cee48d0de28c45": "Ver menos",
  "d1db29ebc76d9f61": "Ocultar barra lateral",
  "d1eb39b09bf52b68": "Mar",
  "d2288d4570696201": "asignaciones. Selecciona una pestaña diferente sobre el calendario para cambiar.",
  "d23e867e38e89ebf": "Lu",
  "d2562b884e5fc0ca": "Esta función requiere la aprobación del administrador",
  "d2c25c86582dcca3": "Error al cargar los límites de la tasa de cargo",
  "d3074e49b63e8eea": "No se pudieron cargar los detalles del bloque de turnos.",
  "d3159e27a9330927": "Publicar turnos",
  "d3a27d96cd0791a2": "Programador",
  "d3c9f5ad4f566898": "Agregar turno",
  "d3eefb6a33d18b7e": "Detalles adicionales (opcional)",
  "d42fc22372f96b6b": "La publicación está tardando más de lo esperado. Por favor, actualiza y verifica tu calendario.",
  "d46233513e29dea8": "Guardar y Salir",
  "d471b71ef926577f": "Respaldos",
  "d4788f256f730423": "Ver perfil",
  "d47d7cb0e4f8fd2b": "Más",
  "d4d66b7ef234d431": "Algo salió mal al publicar los turnos. Por favor, inténtalo de nuevo.",
  "d5147e7b7ca9eb2e": "Finalizar negociación",
  "d56d526dae68d973": "Actualizar el Roster",
  "d5d0a30b517e3bea": "Calendario",
  "d62c7b74e509674f": "Actualizar la tarifa de cargo para todas las {{shiftCount}} turnos de {{qualificationName}} no cubiertos de {{startTime}} a {{endTime}}",
  "d632617f97e809ea": "Asigna una {{qualification}} de tu lista.",
  "d6465f6688fbde51": "Múltiples invitaciones",
  "d64bad115a57a139": "(eliminar)",
  "d696a35bdd1883da": "Perfil",
  "d6df29adae3ef050": "No hay tipos de profesionales incluidos en su contrato todavía. Por favor, contacte al soporte para actualizar su contrato.",
  "d6eafe8235910042": "Descargar",
  "d6f0922393cee1c1": "Todos los turnos después del {{suspensionDate}} están cancelados y no se pueden publicar nuevos turnos. Por favor, envíe un pago o contáctenos a billing@clipboardhealth.com para obtener ayuda.",
  "d7022e3f612fdabf": "Sí, quiero que se penalice al profesional",
  "d7ac4069df5d4780": "Editar horarios de turnos de {{qualification}}",
  "d7cbbb688b2e506c": "seleccionado",
  "d848a26fb462bf92": "Sobrescribir modo de ventana de planificación",
  "d87fdadabf8915bc": "No se pudo eliminar el turno",
  "d8b0b02c84a10f7b": "Asignar personal",
  "d8e450d7767f5756": "Error al asignar personal. Por favor, inténtalo de nuevo.",
  "d900a0ee4fa75a07": "Su cuenta está inactiva",
  "d91ef4ac7730f4e3": "Turnos publicados, pero falla en la actualización del cuestionario",
  "d97968b23b2ee87b": "Agregar a {{workerName}} a la lista de No Devolver",
  "da1f3c19871c3a58": "para que podamos ayudar.",
  "da412499d3a8c4d2": "Tarifa máxima",
  "db0195a83f9872f2": "Exportar horario",
  "db18f17fe5320076": "Dom",
  "dbe0534bb63e57d7": " sobre la cancelación",
  "dc1011d87ddbaa17": "El trabajador me pidió que cancelara",
  "dc90c87e122b2490": "Buscando un reemplazo",
  "dcacb8cfa6feed47": "Calendario y Filtros",
  "dcbf6f252e4b9118": "Vuelva a habilitar esta calificación en la configuración de su lugar de trabajo, o elija una calificación diferente para este turno.",
  "dd290a557b7edd34": "Editar horarios de turnos de {{slotLabel}} el {{dateLabel}} (personalizado)",
  "dd98fb3f6ec2f773": "¿Aceptar {{payRate}}/hr de {{workerName}}?",
  "dd999b9a72aa9249": "Revise los cambios en cola antes de aplicarlos.",
  "ddebf65d3bc063fa": "Razón de eliminación",
  "dea89b13bcd4fe8a": "{{count}} {{professionals}} llegando pronto a su instalación por primera vez. ¡Tómese un momento para compartir las credenciales de {{credentialsType}}!",
  "ded82aa591619802": "Cancelar a {{workerFirstName}} y el turno",
  "def235b01a680a58": "La función de Solicitud de Cierre de Turno está activa para este lugar de trabajo. Por favor, siga el SOP de MPR para cualquier solicitud de verificación o ajuste de turno.",
  "df0fe79898ef413e": "Imprimir",
  "df1a13a9f5372caf": "Agregar Turnos",
  "df2c3b3e38746905": "Tiene turnos no publicados",
  "df2d0dc8e24c0ff3": "Fecha anterior",
  "df615262aa1a1669": "Guardar horarios",
  "dfcea7f40973d63e": "{{time}} el {{day}}",
  "dfe36467102a316b": "Escribe tus comentarios",
  "e0601a73cc98e05a": "Editar hora (personalizado)",
  "e08fe67fcc389bcd": "Todas las calificaciones seleccionadas",
  "e0c7fc6777c19333": "Revisar invitación",
  "e0e5e52c71ebbe8d": "No se puede activar {{typesList}}. Por favor, contacta al soporte de Clipboard Health para configurar las tarifas de carga para tu lugar de trabajo.",
  "e11b517eed438862": "{{workerName}} ha trabajado {{shiftCount}} turnos. Considera enviar comentarios constructivos para ayudarle a mejorar en lugar de bloquearle.",
  "e11f44d32d49dfd2": "Mantener bloque",
  "e1cd25b85547bd46": "Error al crear los turnos",
  "e1eeb204d8795e72": "Eliminar turno",
  "e21f935f11d7e966": "Copiar",
  "e2afc41c0dd59c29": "Abre solo para Clipboard",
  "e3d375c44fd8439c": "Cancelar turno cubierto",
  "e46f0ad78f6d48fa": "Error al cargar los turnos. Por favor, inténtelo de nuevo.",
  "e49583f95ccf5db7": "Por favor, describe el problema para que podamos tomar las medidas adecuadas.",
  "e495b3551c367816": "Se ha aceptado con éxito la negociación y se ha asignado el turno a {{workerName}}",
  "e4b6399c711b5c9b": "Hemos identificado un cambio de propiedad para esta instalación y se requiere un nuevo contrato para continuar utilizando nuestra plataforma. No puede reservar nuevos turnos hasta que el contrato actualizado esté en vigor.",
  "e51258e58c381769": "Su cuenta está suspendida por pagos pendientes",
  "e6f4e5011fc9f121": "Turno cancelado ($)",
  "e708aa6b31284129": "Describa el problema",
  "e7a5b8c3fcb5b8e4": "{{days}} día después de la publicación",
  "e7ecdf0d31e14d57": "{{count}} fechas seleccionadas",
  "e7f458685df1a5c3": "Visible en el calendario",
  "e7f5f530c6b8b2af": "Este trabajador podrá reservar turnos en su instalación nuevamente.",
  "e86b72f85e2114d0": "Bono por hora: {{bonus}}",
  "e8a4d4ad48f48070": "antes de que comience el turno.",
  "e9140d190970aa34": "Cuenta suspendida por pagos pendientes",
  "e981ddae45d8f4ca": "Advertencia",
  "e9999e73a580bacb": "Entiendo que mi lugar de trabajo será cobrado un",
  "e9d5e587f2818276": "Bloquear / DNR",
  "ea100174d29b183e": "Base: {{hours}} hrs/semana",
  "ea210e2ebaa3a507": "Controles de turno de {{dateLabel}}",
  "ea2cc40d45cd99cf": "Seleccionar {{date}}",
  "ea61bc15688d1e48": "¡Copiado!",
  "ea62f7ad88138eed": "Queremos ayudarle a mantener la cobertura durante {{eventName}}. Pida a un administrador o toma de decisiones corporativos que habiliten el Cargo Variable para su lugar de trabajo.",
  "ea8c089e16a3de62": "Descartar banner",
  "eaa0049d20863b68": "¿ser penalizado?",
  "eab0cd8fdf9bccec": "Por hora",
  "eb365f0fe1e6acbb": "Turnos en este bloque",
  "eb69d86d6eecdb6c": "Revisar turnos",
  "ebd61f0962a28e4f": "Su lugar de trabajo no será cobrado con una tarifa de cancelación por cancelar este turno de Roster.",
  "ebf12ef47cf575b3": "Borrador",
  "ebfef07e2d2b1c17": "Elige una hora en el futuro.",
  "ec116342c6998ca9": "Elige una hora",
  "ec53b715f5a4b205": "El turno solo será visible para el profesional invitado. Si no aceptan, el turno no se publicará y necesitarás publicarlo manualmente o invitar a alguien más.",
  "ec6ef45d6169b644": "Mostrar todos los tipos de turnos",
  "ecfe8570868995eb": "Disminuir bono",
  "ed373fec624c3479": "Clipboard ha descontinuado las ofertas de Cuidado Infantil y Educación y ha suspendido todas las cuentas pendientes. Las cuentas pendientes no pueden publicar ningún nuevo turno, pero los turnos futuros que ya están publicados seguirán siendo honrados y trabajados. Por favor, envíe el pago de su saldo restante o contáctenos a billing@clipboardworks.com si tiene alguna pregunta.",
  "ed77e681ad80e655": "Por favor, asegúrese de que los detalles de su contrato estén actualizados antes del {{deadline}}. Si tiene alguna pregunta, comuníquese con",
  "edc48b5a5ae34fe6": "La edición de tiempo y licencia está deshabilitada para los turnos de Roster.",
  "edd32138d380825b": "Profesional seleccionado",
  "ee0f0495791d4693": "ID del turno",
  "ee36016ce41c648c": "Total de turnos: {{shiftCount}}",
  "ee82285b2bef5f54": "Editar tarifa de carga",
  "eebdd24a77d9ad32": "Confirmar",
  "eed8f901692d0856": "Vi",
  "ef3d67c37d8e0333": "Tu respuesta es anónima y es solo para uso interno de Clipboard.",
  "ef80bb8ce97b8d1d": "Error al imprimir las hojas de tiempo",
  "ef8a7e8d561b416e": "Turnos publicados con éxito",
  "f0db9bf158906717": "¿Eliminar de la lista de No Retornar?",
  "f120021c2869066c": "Eliminaremos al trabajador y dejaremos de buscar un reemplazo.",
  "f16a947f6c0952a4": "Solo hombres",
  "f23e6c26374bbc50": "Hacer opcionales los requisitos del documento",
  "f26e99281ea8898f": "Descartar el panel de trabajadores disponibles",
  "f286dc334b128966": "Propuesta de horario enviada",
  "f322556f03221d2d": "Sí, enviar comentarios",
  "f3380f7b44bd70af": "Pegar",
  "f37da14136c22f95": "Eliminar de la lista de No Volver",
  "f3dfa2aef6491990": "Disminuir bonificación por hora",
  "f3fe997b8d1ce818": "Mi",
  "f405af18c7f9b71e": "Este turno será cancelado.",
  "f40d7f51f69edfaf": "Lun",
  "f42dfa382dc36c83": "Si está autorizado para firmar este contrato, hágalo",
  "f491d58207eb7fcb": "Enviado a casa a las {{time}}",
  "f4b4637b4395a437": "No Devolver",
  "f50dcf0f149ab2b2": "Estás publicando",
  "f53a2330667daa5f": "Su lugar de trabajo será cobrado {{feeDisplay}} por el tiempo de este profesional.",
  "f60420bece08cd42": "Cuando esté marcado:",
  "f667a06d7d7ff1b8": "Cargo variable habilitado",
  "f67a23ce7574418d": "Su cuenta está inactiva. Por favor, comuníquese con el soporte de Clipboard Health",
  "f6a30a10bc27be0a": "Reportar un Problema",
  "f6f4688ff23d50c6": "Enviar",
  "f72230410d232ea6": "Personal de la lista desasignado del turno",
  "f7303adee2857203": "{{days}} días después de la publicación",
  "f731562ef07f6f72": "No se encontraron profesionales disponibles.",
  "f7c233114080719b": "Editar hora del turno",
  "f8588524fa4a7822": "Aplicar a todos los turnos de {{shiftGroup}}",
  "f8b506de10564a0c": "Profesional bloqueado",
  "f8d399737b4e2b24": "Si no se acepta, publicar como turno abierto",
  "f8d46c2570e70736": "Más acciones",
  "f8e47f10d5dc8923": "Publicación masiva completa",
  "f929f2c4c375f54e": "Agregar turno de {{slotLabel}} al bloque",
  "fa1c346ae61602cd": "Por favor, selecciona un horario diferente para enviar invitaciones.",
  "fa5f3757ef2291d2": "Disponible para que diferentes profesionales lo reserven",
  "fb3976bbbd316226": "Configurar bloque",
  "fb75f6d7a6206272": "El profesional ha sido agregado a la lista de No Devolver.",
  "fb8108ee5a3955b5": "Error al enviar la propuesta de horario",
  "fbab7e0010099396": "Profesional en el edificio",
  "fbbf67422e5e3648": "Tipos de Turnos",
  "fbed4f5f88700625": "Solo los profesionales de su género seleccionado podrán ver los nuevos turnos que publique. Esto no afectará los turnos que ya ha publicado.",
  "fc00ac0a095eedbf": "{{shiftCount}} turno",
  "fc6e4a408d56be96": "Salir",
  "fc73814ad8b16b82": "La Garantía de Relleno solo se admite para aumentos en turnos individuales.",
  "fc7b2579f42a3c64": "Agregar a la lista de No Volver",
  "fc8a478384f2d805": "El profesional se fue con mi permiso.",
  "fca60b3c431a22a8": "Este profesional ha sido bloqueado por su lugar de trabajo y no se puede invitar.",
  "fcd44004d62fa8ea": "¿Descartar borrador de turno?",
  "fcea6d759b6c1834": "Esta página ha sido actualizada mientras estaba ausente. Actualice para obtener lo último.",
  "fcec91509759ad99": "aquí",
  "fcfdd6491f7b2517": "Cerrar el panel de asignación de personal",
  "fd11f315e1f2cf34": "Turnos abiertos de {{dateLabel}}",
  "fd34be170e1eabc0": "Todos los turnos próximos para el bloque de turnos han sido cancelados",
  "fdc923f7b593d952": "Turnos de {{slotLabel}}, {{filledCount}} ocupados de {{totalCount}}",
  "fdeb71b569e0034d": "Sáb",
  "fdfd43ff69947f68": "Firmado por ",
  "fe8fa011d55a4b13": "{{count}} turno copiado",
  "ff19fd8e9b0a3e85": "Esto no es compatible actualmente con la Garantía de Llenado",
  "ff5956419b448ea0": "El trabajador recibe",
  "ff7ebe47a75b69b6": "Hora de finalización de {{slotLabel}}"
}
